import { useState, useEffect } from 'react'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import { useMemo } from 'react'

const calculatorType = 'Isplative kvote i broj kombinacija'

const IsplativeKvote = () => {
  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [showInputArea, setShowInputArea] = useState(true)

  const [data, setData] = useState({
    values: {
      sysParams: ['', ''],
    },
  })

  const clearFields = () => {
    setData({ values: { sysParams: ['', ''] } })
    setDisabled(true)
  }

  const comb = (n, r) => {
    if (r > n || r < 0) return 0
    if (r === 0 || r === n) return 1
    let res = 1
    for (let i = 1; i <= r; i++) res = (res * (n - i + 1)) / i
    return res
  }

  const minOdd = (n, k) => {
    if (!n || !k || k > n) return ''
    return Math.pow(comb(n, k), 1 / k)
  }

  const minHitPct = (n, k) => {
    if (!n || !k || k > n) return 0
    return (k / n) * 100
  }

  const fmt2 = (val) =>
    isFinite(val) && val !== '' ? Number(val).toFixed(2) : '0.00'

  const calculateAll = () => {
    const [k, n] = data.values.sysParams.map(Number)

    const minQ = minOdd(n, k)
    const pct = minHitPct(n, k)

    const total = n && k && k <= n ? comb(n, k) : 0

    return {
      minQ: fmt2(minQ),
      minPct: k && n ? fmt2(pct) : '',
      totalComb: String(total),
    }
  }

  // Rezultati svih kalkulacija
  const results = useMemo(() => calculateAll(), [data.values])

  const [upisUslovnog, setUpisUslovnog] = useState(0)
  const [upisUkupnog, setUpisUkupnog] = useState(0)
  const [minIsplativo, setMinIsplativno] = useState(0)
  const [minProcenat, setMinProcenat] = useState(0)
  const [ukupanBroj, setUkupanBroj] = useState(0)

  const handleChangeUpisUslovnog = (e) => {
    setUpisUslovnog(e.target.value)
  }

  const handleChangeUpisUkupnog = (e) => {
    setUpisUkupnog(e.target.value)
  }

  const handleCalculate = () => {
    if (upisUslovnog && upisUkupnog) {
      let h76 = parseFloat(upisUkupnog)
      let b76 = parseFloat(upisUslovnog)

      let b62 = b76 // Since b62 and b76 are same
      let p62 = h76 // Similarly p62 and h76

      setMinProcenat(((b62 / p62) * 100).toFixed(2))

      function combin(n, k) {
        if (k === 0 || k === n) return 1
        if (k > n) return 0

        let result = 1
        for (let i = 1; i <= k; i++) {
          result = (result * (n - i + 1)) / i
        }

        return result
      }

      let ukupno = combin(p62, b62)

      let res = JSON.parse(JSON.stringify(ukupno))

      setUkupanBroj(parseFloat(res).toFixed(0))

      setMinIsplativno((parseFloat(res).toFixed(0) ** (1 / b62)).toFixed(2))
    }
  }

  useEffect(() => {
    handleCalculate()
  }, [upisUkupnog, upisUslovnog])

  return (
    <>
      <div className={classesK.container}>
        <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />

        <div className={classesK.contentContainer}>
          <div className={classesK.sectionTitle}>Upis podataka</div>

          <OddsCalculator
            data={data.values}
            setData={setData}
            field={'sysParams'}
            labelPrefix={[
              'Upiši broj traženih pogodaka u sistemu',
              'Broj parova u sistemu',
            ]}
            header='Podaci o sistemu'
            type={['number', 'number']}
            step={['1', '1']}
            min={['1', '1']}
            rows={2}
            setError={setError}
          />
          <ResultsSection
            results={[results.minQ]}
            subtitle={'Min. isplativa kvota  po paru'}
            names={['KVOTA']}
            rows={1}
            allowNegative={true}
          />
          <ResultsSection
            subtitle={['Minimalni procenat (%) pogođenih parova']}
            names={['MIN %']}
            results={[results.minPct]}
            withPercent={true}
            allowNegative={true}
          />
          <ResultsSection
            subtitle={['Ukupan broj kombinacija za odabrani sistem']}
            names={['BR. KOMBINACIJA']}
            results={[results.totalComb]}
            rows={1}
            allowNegative={true}
          />
        </div>
      </div>
    </>
  )
}

export default IsplativeKvote
